import { render } from "./UserAttendance.vue?vue&type=template&id=7b1e8f60"
import script from "./UserAttendance.vue?vue&type=script&lang=js"
export * from "./UserAttendance.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__